import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import { omit } from "lodash";
import initialState from "./recipe-list.store";
import { clearRecipeParsedData, importRecipe, importRecipeFailure, importRecipeSuccessful, loadRecipeList, loadRecipeListFailure, loadRecipeListSuccessful, parseRecipe, parseRecipeFailure, parseRecipeSuccessful, } from "./recipe-list.actions";
import { setKnowledgeBaseItemsFilterExcludedTags, setKnowledgeBaseItemsFilterIncludedTags, setKnowledgeBaseItemsLastUsedSortingDirection, setKnowledgeBaseItemsNameSortingDirection, setKnowledgeBaseItemsOwnershipFilter, setKnowledgeBaseItemsSearchQuery, } from "store/knowledge-base-items-list/knowledge-base-items-list.actions";
import { revokeOwnershipSuccessful, shareOwnershipSuccessful, } from "store/knowledge-base-item/knowledge-base-item.actions";
import { GlobalEntityType } from "shared/types";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(loadRecipeListSuccessful, (state, { payload }) => {
        state.items = payload;
    })
        .addCase(setKnowledgeBaseItemsSearchQuery, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.Recipe) {
            state.searchQuery = payload.query;
        }
    })
        .addCase(setKnowledgeBaseItemsOwnershipFilter, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.Recipe) {
            state.ownershipFilter = payload.ownershipFilter;
        }
    })
        .addCase(setKnowledgeBaseItemsNameSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.Recipe) {
            state.sortingDirections.name = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsLastUsedSortingDirection, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.Recipe) {
            state.sortingDirections.lastUsed = payload.direction;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterIncludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.Recipe) {
            state.tagsFilters.included = payload.tags;
        }
    })
        .addCase(setKnowledgeBaseItemsFilterExcludedTags, (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.Recipe) {
            state.tagsFilters.excluded = payload.tags;
        }
    })
        .addCase(parseRecipeSuccessful, (state, { payload }) => {
        state.parsedData = payload;
    })
        .addMatcher(isAnyOf(shareOwnershipSuccessful, revokeOwnershipSuccessful), (state, { payload }) => {
        if (payload.entityType === GlobalEntityType.Recipe) {
            const existingItem = state.items.find(({ id }) => id === payload.knowledgeBaseItem.id);
            state.items = [
                ...state.items?.filter(({ id }) => id !== payload.knowledgeBaseItem.id),
                { ...existingItem, ...omit(payload.knowledgeBaseItem, "state") },
            ];
        }
    })
        .addMatcher(isAnyOf(importRecipeSuccessful, clearRecipeParsedData), (state) => {
        state.parsedData = null;
    })
        .addMatcher(isAnyOf(loadRecipeList, parseRecipe, importRecipe), (state) => {
        state.loading = true;
    })
        .addMatcher(isAnyOf(loadRecipeListSuccessful, loadRecipeListFailure, parseRecipeSuccessful, parseRecipeFailure, importRecipeSuccessful, importRecipeFailure), (state) => {
        state.loading = false;
    });
});
